export default /^[\u0400-\u04FF-\s]+$/;
